import { useEffect, useState } from "react";
import Filter from "src/components/Filter";
import List from "src/components/List";
import { TrafficFilter } from "src/types/FormTypes";
import { useTrafficInfoFilters } from "src/hooks/useTrafficInfoFilters";

export default function TrafficInfo() {
  const { filters, loading } = useTrafficInfoFilters();

  const [draftFilter, setDraftFilter] = useState<TrafficFilter>({
    modes: {},
    time: "today",
  });

  const [appliedFilter, setAppliedFilter] = useState<TrafficFilter>({
    modes: {},
    time: "today",
  });

  useEffect(() => {
    if (!filters.length) return;

    const initial: TrafficFilter = {
      modes: Object.fromEntries(filters.map((f) => [f.Key, true])),
      time: "today",
    };

    setDraftFilter(initial);
    setAppliedFilter(initial);
  }, [filters]);

  if (loading) return <p>Laddar filter…</p>;
  if (!filters.length) return null;

  return (
    <>
      <Filter
        filters={filters}
        value={draftFilter}
        onChange={setDraftFilter}
        onApply={() => setAppliedFilter(draftFilter)}
      />

      <List filter={appliedFilter} />
    </>
  );
}
